import { LOGOUT } from '../../../store/Types';

export const ALL_CIUDADES = 'ALL_CIUDADES';
export const ACTIVO_CIUDADES = 'ACTIVO_CIUDADES';
export const ALERT_VIEW_CIUDADES = 'ALERT_VIEW_CIUDADES';
export const LOADING_ALL_CIUDADES = 'LOADING_ALL_CIUDADES';
export const PARAMS_CIUDADES = 'PARAMS_CIUDADES';
export const SEARCH_CIUDADES = 'SEARCH_CIUDADES';

const initialState = {
  all: [],
};

export const ciudadesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_CIUDADES:
      return {
        ...state,
        all: action.payload.data,
      };
    case LOADING_ALL_CIUDADES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
